import styled from 'styled-components';
import coverLandingPage from '../../assets/img/cover-landing-page.png';

import { fonts } from '../../styles/stylesheets';

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  background: 
    linear-gradient(180deg, #FFFFFF -18.33%, rgba(255, 255, 255, 0.72) 69.67%),
    url(${coverLandingPage}) center top no-repeat;
  background-size: cover;
  background-blend-mode: normal;
  padding: 40px 24px 20px;
  font-family: ${fonts.primary};
  span, input, input::placeholder {
    font-family: ${fonts.primary}  !important;
  }
`;

export const Logotipo = styled.img`
  width: 200px;
  height: 60px;
  margin-bottom: 40px;
`;

export const WelcomeUser = styled.h3`
  margin-bottom: 40px;
  font-weight: 400;
  font-size: 24px;
`;

export const SearchContent = styled.div`
  min-width: 320px;
  width: 70%;
`;

export const SearchHelp = styled.div`
  margin-top: 16px;
  font-size: 14px;
`;
